import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: false,
    showMain: true,
    layout: "default",
    email: '',
    token: '',
    auth : '',
    login: false,
    s_code:'',
    push : '',
    mobile : false,
    show_mobile : false,
    m_member: 'N',
    m_organization: 'N',
    m_sales: 'N',
    m_extra: 'N',
    m_tree: 'N',
    m_statistics: 'N',
    m_coin_member: 'N',
    m_coin_admin: 'N',
    m_coin: 'N',
    m_admin: 'N',
    m_site: 'N',
    m_system : 'N'
  },
  plugins: [createPersistedState()],
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
        state.show_mobile = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
        state.show_mobile = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    Login(state, info) {
      state.email = '';
      state.token = info.token;
      state.login = true;
      const menu = info.menu;
      state.m_member = menu.member;
      state.m_organization = menu.organization;
      state.m_sales = menu.sales;
      state.m_extra = menu.extra;
      state.m_tree = menu.tree;
      state.m_statistics = menu.statistics;
      state.m_coin_member = menu.coin_member;
      state.m_coin_admin = menu.coin_admin;
      state.m_coin = menu.coin;
      state.m_admin = menu.admin;
      state.m_site = menu.site;
      state.m_system = menu.system;
    },
    Logout(state) {
      state.email = '';
      state.token = '';
      state.login = false;
      state.m_member = 'N';
      state.m_organization = 'N';
      state.m_sales = 'N';
      state.m_extra = 'N';
      state.m_tree = 'N';
      state.m_statistics = 'N';
      state.m_coin_member = 'N';
      state.m_coin_admin = 'N';
      state.m_coin = 'N';
      state.m_admin = 'N';
      state.m_site = 'N';
      state.m_system = 'N';
    },
    SetEmail(state, email) {
      state.email = email;
    },
    SetPush(state, push) {
      state.push = push;
    },
    CheckMobile(state, info) {
      state.mobile = info;
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    CHECKMOBILE({ commit }, info) {
      commit("CheckMobile", info);
    },
    SETLOGOUT ({commit}) {
      commit('Logout')
    },
    SETLOGIN ({commit},info) {
      commit('Login',info)
    },
    SETEMAIL ({commit},mem_info) {
      commit('SetEmail',mem_info)
    },
    SETPUSH({commit},token){
      commit('SetPush',token)
    }
  },
  getters: {}
});
